var m = require('mithril');
var prop = require('mithril/stream');
var Model = require('../libs/Model');
var loaders = require('../layout/components/loaders');
var verticalListItem = require('./verticalListItem');
var paginationWithSearch = require('../data/components/paginationWithSearch');

function urlForRecord (record) {
  return '/api/v1/dashboardonly/' + record['@rid'].slice(1);
}

function isValidDashboardVertex(vertex) {
  return vertex &&
    vertex['@rid'] &&
    vertex['@class'] == 'Dashboard' &&
    typeof vertex.name === 'string' &&
    vertex.name.trim().length > 0;
}

function dashboardEdges(edges) {
  return (edges || [])
    .filter(function (record) {
      return record && isValidDashboardVertex(record.in);
    })
    .map(function (record) {
      record.in.out_Contains = dashboardEdges(record.in.out_Contains);
      return record;
    });
}

function displayNameForRoot(rootResult, tree) {
  if (rootResult && rootResult.name && rootResult.name !== 'root') {
    return rootResult.name;
  }
  return tree.name || 'Home';
}

var trees = {};

trees.oninit = function (vnode) {
  var ctrl = this;
  ctrl.trees = vnode.attrs.trees;
  ctrl.selector = vnode.attrs.selector;
  ctrl.node = prop({});
  ctrl.activeTree = prop({});
  ctrl.label = vnode.attrs.label;
  ctrl.rootNode = null;
  ctrl.newNode = prop(false);
  ctrl.dataToShow = [];

  ctrl.rootEntryFor = function (rootResult, tree, idx) {
    return {
      name: displayNameForRoot(rootResult, tree),
      treeIndex: idx,
      isDashboardTreeRoot: true,
      children: dashboardEdges(rootResult['out_' + tree.edgeClass])
    };
  };

  ctrl.getActiveTree = function () {
    return typeof ctrl.activeTree === 'function' ? ctrl.activeTree() : ctrl.activeTree;
  };

  ctrl.setActiveTree = function (tree) {
    ctrl.activeTree = tree || {};
  };

  ctrl.getRoots = function () {
    ctrl.node({children:[]});
    Promise.all(ctrl.trees.map(function (tree) {
      return loaders.requestWithLoader({
        loader: 'background',
        url: tree['@id'],
        method: 'GET'
      })
    })).then(function (results) {
      ctrl.roots = results.map(function (rootResult, idx) {
        return ctrl.rootEntryFor(rootResult, ctrl.trees[idx], idx);
      })
      ctrl.rootNode = {
        children: ctrl.roots,
        '@rid': results[0]['@rid'],
        '@class': results[0]['@class'],
        name: results[0].name || ctrl.trees[0] && ctrl.trees[0].name,
        ancestors: []
      };
      ctrl.node(ctrl.rootNode);
      ctrl.newNode(true);
      if (!ctrl.getActiveTree() || !ctrl.getActiveTree().leafClass) {
        ctrl.setActiveTree(ctrl.trees[0] || {});
      }
    })
  }

  ctrl.home = function () {
    ctrl.node(ctrl.rootNode || {children: ctrl.roots});
    ctrl.newNode(true);
  }

  ctrl.selectTree = function (root) {
    if (root && typeof root.treeIndex === 'number') {
      return ctrl.setActiveTree(ctrl.trees[root.treeIndex]);
    }

    ctrl.setActiveTree(ctrl.trees.find(function (tree) {
      return root.name === tree.root.name;
    }));
  }

  ctrl.navigateNode = function (node) {
    var activeTree = ctrl.getActiveTree();
    if (!activeTree || !activeTree.leafClass) {
      activeTree = ctrl.trees[0] || {};
      ctrl.setActiveTree(activeTree);
    }

    if (!node['@class']) {
      var rootEntry = node && typeof node.treeIndex === 'number' && ctrl.roots[node.treeIndex] ? ctrl.roots[node.treeIndex] : node;
      ctrl.selectTree(rootEntry);
      ctrl.node(rootEntry);
      ctrl.newNode(true);
      return;
    }

    var currentNode = ctrl.node();

    return loaders.requestWithLoader({
      loader: 'background',
      url: urlForRecord(node),
      method: 'GET'
    })
    .then(function (res) {
      res.out_Contains = dashboardEdges(res.out_Contains);
      var ancestorClass = activeTree.ancestorClass;
      if (ancestorClass && (!res[ancestorClass] || res[ancestorClass].length === 0)) {
        var currentAncestors = currentNode && currentNode[ancestorClass] ? currentNode[ancestorClass].slice() : [];
        if (currentNode && currentNode['@rid']) {
          currentAncestors.push({
            name: currentNode.name || 'Home',
            '@rid': currentNode['@rid'],
            '@class': currentNode['@class']
          });
        }
        res[ancestorClass] = currentAncestors;
      }
      ctrl.node(res);
      ctrl.newNode(true);
    });
  }

  ctrl.selectNode = function (node) {
    return ctrl.selector(node)
  }

  ctrl.getRoots();
}

function childVertex(child) {
  return child && child.in ? child.in : child;
}

function normalizeChildForSearch(child) {
  var vertex = childVertex(child);
  if (!vertex || !vertex['@rid']) {
    return child;
  }
  return Object.assign({}, child, {
    name: vertex.name || child.name || '',
    '@rid': vertex['@rid'],
    '@class': vertex['@class']
  });
}

trees.view = function () {
  var ctrl = this;

  var activeTree = ctrl.getActiveTree ? ctrl.getActiveTree() : (typeof ctrl.activeTree === 'function' ? ctrl.activeTree() : ctrl.activeTree);
  var ancestors = activeTree && activeTree.ancestorClass ? ctrl.node()[activeTree.ancestorClass] : ctrl.node().ancestors;
  var displayAncestors = Array.isArray(ancestors) ? ancestors.slice().filter(function (ancestor) {
    return !ancestor || ancestor.name !== 'root';
  }) : [];
  var rootRid = ctrl.rootNode && ctrl.rootNode['@rid'];
  var isAtRoot = ctrl.node()['@rid'] === rootRid;
  var children = ctrl.node().children || (activeTree && activeTree.edgeClass ? ctrl.node()['out_' + activeTree.edgeClass] : []) || [];
  var searchableChildren = children.map(normalizeChildForSearch);

  return m('div.mb2', [
    m('label', 'Select '+ ctrl.label +':'),
    m('br'),
    m("div.mb3.pb2.bb.bw1.b--mid-gray.near-white",  [
      !ctrl.node().children && (!activeTree || !activeTree.ancestorClass) ? null :
      isAtRoot ? null :
        m('div.dib-ns.mr2.blue.pointer', {onclick: ctrl.home}, [
          'Home',
          ' / '
        ]),
      function () {
        if (displayAncestors.length > 0) {
          return displayAncestors.map(function (ancestor, idx){
            var isLast = (idx + 1) === displayAncestors.length;
            return m('div.dib-ns.mr2', {
              class: isLast ? "active" : "blue",
              onclick: ctrl.navigateNode.bind(this, ancestor)
            }, [
              ancestor.name,
              ' / '
            ])
          })        
        }
      }()
    ]),
    m(paginationWithSearch, {
      data: searchableChildren,
      dataToShow: ctrl.dataToShow,
      newNode: ctrl.newNode,
      placeHolder: 'Search dashboard',
      fieldsToSearch: ['name']
    }, [
    m('div', ctrl.dataToShow.map(function (child, idx) {
      if (typeof child === 'function') {
        child = child()
      }

      var rootEntry = child && child.isDashboardTreeRoot && ctrl.roots ? ctrl.roots[child.treeIndex] : null;
      var vertex = child.in;
      let containsChildDasboard;
      if(vertex && vertex.out_Contains){
        (vertex.out_Contains || []).forEach(containsEdge => {
          if(containsEdge.in['@class'] == 'Dashboard') containsChildDasboard = true;
        });
      }
      
      if (rootEntry && ctrl.node()['@class']) {
        return m(verticalListItem, {
          label: m('span', [
            child.name,
            m('i', {
              class: 'dark-blue ion-ios-arrow-right ml2 f3 b'})
            ]),
          labelClass: 'dark-blue', 
          onclickLabel: () =>{
            ctrl.node(rootEntry);
            ctrl.selectTree(rootEntry);
            ctrl.newNode(true);
          }
          },[
            m('i', {onclick: ctrl.selectNode.bind(this, ctrl.node()), class: 'fr f3 b ' + (ctrl.selector()['@rid'] === ctrl.node()['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')})
          ]
        )
      }

      if (!vertex || !vertex['@class']) return;

      if (activeTree && vertex['@class'] === activeTree.leafClass && Array.isArray(vertex.out_Contains) && vertex.out_Contains.length > 0 && containsChildDasboard) { 
        return m(verticalListItem, 
          {
            onclickLabel: ctrl.navigateNode.bind(this, vertex),
            label: m('span',[
              vertex.name, 
              m('i', {class: 'dark-blue ion-ios-arrow-right ml2 f3 b'})
            ]),
            labelClass: 'dark-blue'
          },[
          m('i', {onclick: ctrl.selectNode.bind(this, vertex), class: 'fr f3 b ' + (ctrl.selector()['@rid'] === vertex['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')})
        ])
      }
      
      if (activeTree && vertex['@class'] === activeTree.leafClass) {
        return m(verticalListItem, {label: vertex.name},[
          m('i', {onclick: ctrl.selectNode.bind(this, vertex), class: 'fr f3 b ' + (ctrl.selector()['@rid'] === vertex['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')})
        ])
      }
    }))
    ])
  ])
}

module.exports = trees;
